export const RunningExperiments = {
  ZERO_NINETY_FIVE: 'ZeroNinetyFive_01',
  ZERO_NINETY_FIVE_FB: 'ZeroNinetyFiveFB_01',
  ZERO_NINETY_FIVE_MINING_RIG: 'ZeroNinetyFiveMiningRig_05',
  ZERO_NINETY_FIVE_DIGITAL_CURRENCY: 'ZeroNinetyFiveDigitalCurrency_02',
  DIGITAL_CURRENCY_CHECK_OFFERS: 'DigitalCurrencyCheckOffers_04',
  GPS_GLITCH: 'GPS_Glitch_01',
  FORM_TYPE: 'FormType_01',
  MIXPANEL_ENABLED: 'MixpanelEnabled_01',
}

export enum GPS_GLITCH {
  a = 'a/gpsGlitchToGaming',
  b = 'b/nothing'
}

export enum DIGITAL_CURRENCY_CHECK_OFFERS {
  a = 'a/checkout',
  b = 'b/checkInventory'
}
